import Scrollout from 'scroll-out';

Scrollout({
    targets: ".griglia__item",
    threshold: 0.9,
    onShown : function(el, ctx, ciao) {
        if (ctx.index %2 == 0) {
            el.classList.add('animated', 'fadeInLeft')
        } else {
            el.classList.add("animated", "fadeInRight");
            
        }
        
    }
});